var _style, _defs, _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditSquareGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D9D9D9;filter:url(#Adobe_OpacityMaskFilter);}\r\n\t.st1{mask:url(#mask0_4606_270_00000078766443209442591180000002844950184985293468_);}\r\n\t.st2{fill:#117569;}\r\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 4,
    y: 2.1,
    width: 17.8,
    height: 17.9
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 2.1,
    width: 17.8,
    height: 17.9,
    id: "mask0_4606_270_00000078766443209442591180000002844950184985293468_"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M5.6,20c-0.5,0-0.8-0.2-1.2-0.5C4.2,19.2,4,18.8,4,18.4V5.6c0-0.5,0.2-0.8,0.5-1.2C4.8,4.2,5.2,4,5.6,4H14 l-1,1H5.6C5.5,5,5.3,5.1,5.2,5.2C5.1,5.3,5,5.5,5,5.6v12.8c0,0.2,0.1,0.3,0.2,0.4C5.3,18.9,5.5,19,5.6,19h12.8 c0.2,0,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.3,0.2-0.4v-7.5l1-1v8.5c0,0.5-0.2,0.8-0.5,1.2c-0.3,0.3-0.7,0.5-1.2,0.5H5.6z M10,14v-2.6 l8.9-8.9c0.1-0.1,0.2-0.2,0.3-0.2c0.1,0,0.2-0.1,0.4-0.1c0.1,0,0.2,0,0.4,0.1c0.1,0,0.2,0.1,0.3,0.2l1.1,1.1 c0.1,0.1,0.2,0.2,0.2,0.4c0.1,0.1,0.1,0.3,0.1,0.4c0,0.1,0,0.3-0.1,0.4c0,0.1-0.1,0.2-0.2,0.3l-9,9H10z M11,13h1.1l6.7-6.7 l-0.5-0.5l-0.6-0.6L11,11.8V13z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSquareGreen);
export default __webpack_public_path__ + "static/media/edit-square-green.4eb4767ff858223708335c7f3ed1f664.svg";
export { ForwardRef as ReactComponent };